import { Link, useLocation, useParams } from 'react-router-dom';
import { FolderKanban, LayoutDashboard, LogOut, ScrollText, Settings, Users } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useCurrentOrganization } from '../../contexts/OrganizationContext';
import './SideNav.css';

export function SideNav() {
  const { user, logout } = useAuth();
  const { currentOrg, isAdmin } = useCurrentOrganization();
  const location = useLocation();
  const { orgId } = useParams<{ orgId?: string }>();

  const activeOrgId = orgId || currentOrg?.id;

  const isActive = (path: string) => location.pathname.startsWith(path);

  const initial = user?.name?.charAt(0).toUpperCase() || 'U';

  return (
    <aside className="sidenav">
      <nav className="sidenav__nav">
        {activeOrgId && (
          <div className="sidenav__section">
            <div className="sidenav__section-header">{currentOrg?.name || 'Organization'}</div>

            <Link
              to={`/organizations/${activeOrgId}`}
              className={`sidenav__item ${location.pathname === `/organizations/${activeOrgId}` ? 'active' : ''}`}
            >
              <LayoutDashboard size={16} aria-hidden="true" />
              Overview
            </Link>

            <Link
              to={`/organizations/${activeOrgId}/members`}
              className={`sidenav__item ${isActive(`/organizations/${activeOrgId}/members`) ? 'active' : ''}`}
            >
              <Users size={16} aria-hidden="true" />
              Members
            </Link>

            <Link
              to={`/organizations/${activeOrgId}/projects`}
              className={`sidenav__item ${
                isActive(`/organizations/${activeOrgId}/projects`) ||
                location.pathname.startsWith('/projects/')
                  ? 'active'
                  : ''
              }`}
            >
              <FolderKanban size={16} aria-hidden="true" />
              Projects
            </Link>

            {isAdmin && (
              <>
                <Link
                  to={`/organizations/${activeOrgId}/audit-log`}
                  className={`sidenav__item ${isActive(`/organizations/${activeOrgId}/audit-log`) ? 'active' : ''}`}
                >
                  <ScrollText size={16} aria-hidden="true" />
                  Audit log
                </Link>
                <Link
                  to={`/organizations/${activeOrgId}/settings`}
                  className={`sidenav__item ${isActive(`/organizations/${activeOrgId}/settings`) ? 'active' : ''}`}
                >
                  <Settings size={16} aria-hidden="true" />
                  Settings
                </Link>
              </>
            )}
          </div>
        )}
      </nav>

      <div className="sidenav__footer">
        <Link
          to="/account"
          className={`sidenav__user ${isActive('/account') ? 'active' : ''}`}
          aria-label="Account"
          title="Account"
        >
          <div className="sidenav__avatar">{initial}</div>
          <div className="sidenav__user-text">
            <span className="sidenav__user-name">{user?.name}</span>
            <span className="sidenav__user-email">{user?.email}</span>
          </div>
        </Link>
        <button
          type="button"
          className="sidenav__signout"
          onClick={logout}
          title="Sign out"
          aria-label="Sign out"
        >
          <LogOut size={16} aria-hidden="true" />
        </button>
      </div>
    </aside>
  );
}
